import React, {useEffect, useState} from "react";
import { FlexColumnWidth100, FlexRow } from "../../../components/ui/Content"
import {useTranslation} from "react-i18next";
import {InputElement} from "../../../ui/Input/Input";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {cleanError, SendMailCode} from "../slice";
import {RegisterInputContainer} from "../../../components/ui/InputSearch";
import {Caption2PointerLink} from "../../../components/Font";
import {LocalStorageEnum} from "../../../enum/localStorage";
import { ArrowRightBlue, Info, SuccessIcon } from '../../../icon/Icon'
import { useTheme } from 'styled-components'

interface EnterMailProps {
    edit: boolean
    onCancel(): void
    isDisabled?: boolean
}

export const EnterMail = ({onCancel, edit, isDisabled}: EnterMailProps) => {
    const dispatch = useAppDispatch()
    const {t} = useTranslation();
    const {isFetching, error, mail, phone, registerInitData, mailSubmit} = useAppSelector(state => state.auth)
    const [mailInput, setMailInput] = useState(mail ?? '')
    const Theme = useTheme();

    useEffect(() => {
        const input = document.querySelector('.registerMailInput') as HTMLInputElement
        if (input && phone) {
            input.focus()
        }
    }, [phone])

    useEffect(() => {
        const mail = localStorage.getItem(LocalStorageEnum.mail)
        if (mail) setMailInput(mail)
    }, [])

    useEffect(() => {
        if (registerInitData) {
            setMailInput(registerInitData.email)
        }
    }, [registerInitData])

    const submit = () => {
        if (mailInput === mail) {
            onCancel()
        } else {
            dispatch(SendMailCode({
                email: mailInput
            }))
            // dispatch(fakeEmailSubmit(mailInput))
        }
    }

    const isApproveMessageShow = !isFetching && mailInput.length > 7 && mail !== mailInput
    const modalIcon = () => {
        if (mailSubmit) {
            return (
              <SuccessIcon />
            )
        }
        if (!isApproveMessageShow) return
        return (
          isApproveMessageShow && <Info
            style={{
                marginLeft: '5px',
                fill: error['email'] ? Theme.color.danger : Theme.color.warning,
            }}
          />
        )
    }

    return <FlexColumnWidth100>
        <RegisterInputContainer>
            <InputElement placeholder={t('passport.registrationForm.emailForm.hint')}
                noClear={mailSubmit && mailInput === mail}
                className={'registerMailInput'}
                value={mailInput}
                error={error['email']}
                disabled={isDisabled}
                onChange={value => {
                    setMailInput(value)
                    if (error['email']) {
                        dispatch(cleanError('email'))
                    }
                }}
                icon={modalIcon()}
                onKeyDown={(key) => {
                    if ((key === 'Enter' || key === 'NumpadEnter') && mailInput.length > 7) {
                        submit()
                    }
                }}/>
        </RegisterInputContainer>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between'}}>
            {isApproveMessageShow && <Caption2PointerLink style={{marginTop: '10px'}} onClick={submit}>
            <FlexRow style={{ fontSize: '16px', lineHeight: '22px', alignItems: 'center', gap: '5px' }}>
                {t('auth.sendVerificationCode')}
                <ArrowRightBlue width='15' height='15' />
            </FlexRow>
        </Caption2PointerLink>
            }
            {edit && <Caption2PointerLink
                onClick={onCancel}>
                {t('auth.cancel')}
            </Caption2PointerLink>}
        </div>
    </FlexColumnWidth100>
}
